import React, { useState } from 'react'
import _lodash from 'lodash'
import styles from './index.module.less'
import { CloseCircleOutlined, EyeOutlined } from '@ant-design/icons'
import imgexample from '@/static/img/imgexample.png'
const SixFacesChart = () => {
  const [detailsData, setdetailsData] = useState(
    JSON.parse(sessionStorage.getItem('detailsData'))
  )

  // 删除图片
  const handleDeleteSixImage = (e, index) => {
    const detailsDataClone = _lodash.clone(detailsData)
    detailsDataClone.six_images.splice(index, 1)
    setdetailsData(detailsDataClone)
    sessionStorage.setItem('detailsData', JSON.stringify(detailsDataClone))
  }

  return (
    <div style={{ display: 'flex', border: '1px solid #d9d9d9' }}>
      <div style={{ width: '100%' }}>
        <div
          style={{
            width: '100%',
            marginBottom: '24px',
            marginTop: '56px',
            textAlign: 'center'
          }}
        >
          <div style={{ marginLeft: '32px', textAlign: 'left', color: 'red' }}>
            注：请上传完整，
            要求：六面图清晰完整，必须带公章
          </div>

          <div
            style={{
              border: '1px solid lavender',
              margin: '0px 32px 32px 32px',
              padding: '16px 16px'
            }}
          >
            <span
              style={{
                display: 'flex'
              // width: "7%",
              // position:'relative'
              }}
              className={styles.uploadimg}
            >
              <span>
                {detailsData &&
                detailsData.six_images &&
                detailsData.six_images.length !== 0
                  ? detailsData.six_images.map((j, k) => {
                    return (
                      <span className={styles.img_style} key={k}>
                        <span className={styles.imgstyle}>
                          <a
                            href={j}
                            className={styles.iconstyle}
                            style={{
                              fontSize: '18px',
                              color: 'white'
                            }}
                            target="_blank"
                          >
                            <EyeOutlined />
                          </a>

                          <CloseCircleOutlined
                            className={styles.iconstyles}
                            style={{
                              position: 'absolute',
                              top: '-4px',
                              right: '-6px'
                            }}
                            onClick={(e) => handleDeleteSixImage(e, k)}
                            type="close-circle"
                          />
                        </span>
                        <img
                          src={j}
                          style={{
                            width: '100%',
                            height: '100%'
                          }}
                        ></img>
                      </span>
                    )
                  })
                  : '暂无图片'}
              </span>
            </span>
          </div>
          <div style={{ marginLeft: '32px', textAlign: 'left' }}>实例：六面图</div>

          <div
            style={{
              border: '1px solid lavender',
              margin: '0px 32px 32px 32px',
              padding: '16px 16px'
            }}>
            <img style={{width: '100%'}} src={imgexample}></img>
          </div>
        </div>
      </div>
    </div>
  )
}
export default SixFacesChart



// WEBPACK FOOTER //
// ./src/pages/commoditymanagement/newproductdetails/six-faces-chart.js